module.exports = __webpack_public_path__ + "assets/pdf/E02-en-increasing-flash-floods.3f8c4b16.pdf";